import { render, staticRenderFns } from "./uploadProductRetailerMargin.vue?vue&type=template&id=8ec0e9da&scoped=true"
import script from "./uploadProductRetailerMargin.vue?vue&type=script&lang=js"
export * from "./uploadProductRetailerMargin.vue?vue&type=script&lang=js"
import style0 from "./uploadProductRetailerMargin.vue?vue&type=style&index=0&id=8ec0e9da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec0e9da",
  null
  
)

export default component.exports